import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Btn } from "@/components/common";
import { Trash2, Plus } from "lucide-react";

const inp = "px-2 py-1 text-sm rounded border border-slate-300 bg-white";

export default function MarketingItems({ cfg, onSaved }) {
  const [items, setItems] = useState(cfg.items);
  const set = (i, k, v) => setItems(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const save = async () => {
    try {
      await api.put("/marketing/settings", { items: items.map((x) => ({ ...x, price: Number(x.price), our_pct: x.mode === "percent" ? Number(x.our_pct) : null })) });
      toast.success("Articoli salvati"); onSaved();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="rounded-lg border border-slate-200 p-3 space-y-2" data-testid="mk-items">
      <div className="text-xs font-semibold text-slate-600">Articoli di marketing</div>
      {items.map((x, i) => (
        <div key={x.id || i} className="flex flex-wrap items-center gap-2" data-testid={`mk-item-${i}`}>
          <input data-testid={`mk-item-name-${i}`} value={x.name} onChange={(e) => set(i, "name", e.target.value)} placeholder="Nome articolo" className={`${inp} w-40`} />
          <label className="text-[11px] text-slate-500">Prezzo € <input data-testid={`mk-item-price-${i}`} type="number" value={x.price} onChange={(e) => set(i, "price", e.target.value)} className={`${inp} w-20`} /></label>
          <select data-testid={`mk-item-mode-${i}`} value={x.mode} onChange={(e) => set(i, "mode", e.target.value)} className={inp}>
            <option value="percent">Percentuale mia (resto a terzi)</option>
            <option value="cost">Costo scritto a ogni vendita</option>
          </select>
          {x.mode === "percent" && <label className="text-[11px] text-slate-500">Mia quota % <input data-testid={`mk-item-pct-${i}`} type="number" value={x.our_pct ?? ""} onChange={(e) => set(i, "our_pct", e.target.value)} className={`${inp} w-16`} /></label>}
          {items.length > 1 && <button data-testid={`mk-item-del-${i}`} onClick={() => setItems(items.filter((_, j) => j !== i))} className="text-rose-500"><Trash2 size={14} /></button>}
        </div>
      ))}
      <div className="flex gap-2">
        <Btn variant="secondary" data-testid="mk-item-add" onClick={() => setItems([...items, { id: "", name: "", price: 0, mode: "cost", our_pct: null }])}><Plus size={14} /> Aggiungi articolo</Btn>
        <Btn data-testid="mk-items-save" onClick={save}>Salva articoli</Btn>
      </div>
    </div>
  );
}
